<template>
  <el-select 
    v-model="internalValue"
    :disabled="disabled"
    :teleported="false"
    :popper-options="popperOptions"
    :popper-class="popperClass"
    :placeholder="placeholder"
    :collapse-tags="collapseTags"
    multiple
    filterable 
    default-first-option
    no-match-text="No matches found"
    no-data-text="No options available"
  >
    <slot />
  </el-select>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PopperAssistant from '@/helpers/popper-assistant'

/* Wrapper class for multi selects */
export default defineComponent({
  name: 'MultiSelect',

  props: {
    modelValue: {
      type: Array as () => any[],
      default: [] as any[],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    popperClass: {
      type: String,
      default: '',
    },
    collapseTags: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  data() {
    return {
      // Fixed inside dialogs and drawers, so their scrolling body doesn't cut the dropdown off
      popperOptions: {},
    }
  },

  computed: {
    internalValue: {
      get(): any {
        return this.modelValue
      },
      set(value: any): any {
        this.$emit('update:modelValue', value)
      },
    },
  },

  mounted() {
    this.popperOptions = PopperAssistant.inPlacePopperOptions(this.$el)
  },
})
</script>
